<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.66675 8H11.3334" stroke="currentColor" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGMinus',
};
</script>

<style scoped>

</style>
